export default {
  TYPE: {
    ADMIN: 1,
    TEAM: 3,
  },
};

export const adminAccessGroupSlugs = {
  LIST_USER: 'list-user',
  CREATE_USER: 'create-user',
  UPDATE_USER: 'edit-user',
  UPDATE_USER_ROLE: 'update-user-role',
  MANAGE_ROLE: 'manage-role',
  LIST_TEAM: 'list-team',
  CREATE_TEAM: 'create-team',
  EDIT_TEAM: 'edit-team',
  INVITE_REMOVE_TEAM_MEMBER: 'invite-remove-member',
  LIST_LICENSE: 'list-license',
  EDIT_LICENSE: 'edit-license',
  LIST_PAYMENT: 'list-payment',
  CREATE_PAYMENT: 'create-payment',
  ACCEPT_DECLINE_PAYMENT: 'accept-decline-payment',
};

export const adminAccessGroupRules = [
  {
    name: 'User',
    class: 'user',
    desc: 'policy for managing user utility',
    slugs: [
      adminAccessGroupSlugs.LIST_USER,
      adminAccessGroupSlugs.CREATE_USER,
      adminAccessGroupSlugs.UPDATE_USER,
      adminAccessGroupSlugs.UPDATE_USER_ROLE,
    ],
  },
  {
    name: 'Role',
    class: 'role',
    desc: 'policy for managing system role',
    slugs: [adminAccessGroupSlugs.MANAGE_ROLE],
  },
  {
    name: 'Team',
    class: 'team',
    desc: 'policy for managing team utility',
    slugs: [
      adminAccessGroupSlugs.LIST_TEAM,
      adminAccessGroupSlugs.CREATE_TEAM,
      adminAccessGroupSlugs.EDIT_TEAM,
      adminAccessGroupSlugs.INVITE_REMOVE_TEAM_MEMBER,
    ],
  },
  {
    name: 'License',
    class: 'license',
    desc: 'default policy for managing team-license utility',
    slugs: [
      adminAccessGroupSlugs.LIST_LICENSE,
      adminAccessGroupSlugs.EDIT_LICENSE,
    ],
  },
  {
    name: 'Payment',
    class: 'payment',
    desc: 'policy for managing payment utility',
    slugs: [
      adminAccessGroupSlugs.LIST_PAYMENT,
      adminAccessGroupSlugs.CREATE_PAYMENT,
      adminAccessGroupSlugs.ACCEPT_DECLINE_PAYMENT,
    ],
  },
];

export const teamAccessGroupsSlugs = {
  DASHBOARD: 'dashboard',
  LIST_MEMBERS: 'list-members',
  INVITE_REMOVE_TEAM_MEMBER: 'invite-remove-team-member',
  MANAGE_TEAM_ROLES: 'manage-team-roles',
  TEAM_SETTING: 'team-setting',
  TEAM_LICENSE: 'team-license',
  CREATE_TEAM_PAYMENT: 'create-team-payment',
  PAYMENT_HISTORY: 'payment-history',
  LIST_SOCIAL_ACCOUNT: 'list-social-account',
  SOCIAL_ACCOUNT: 'social-account',
  LIST_CONTACTS: 'list-contacts',
  CREATE_CONTACT: 'create-contact',
  EDIT_CONTACT: 'edit-contact',
  LIST_CAMPAIGN: 'list-campaign',
  CREATE_CAMPAIGN: 'create-campaign',
  EDIT_CAMPAIGN: 'edit-campaign',
  LIST_ADS_SET: 'list-ads-set',
  CREATE_ADS_SET: 'create-ads-set',
  EDIT_ADS_SET: 'edit-ads-set',
  LIST_ADS: 'list-ads',
  CREATE_ADS: 'create-ads',
  EDIT_ADS: 'edit-ads',
  LIST_INTEGRATOR: 'integrator',
  CREATE_INTEGRATOR: 'create-integrator',
  EDIT_INTEGRATOR: 'edit-integrator',
  INTEGRATOR_APPROVAL: 'integrator-approval',
  LIST_ANALYZER: 'list-analyzer',
  CREATE_ANALYZER: 'create-analyzer',
  LIST_REFINER: 'list-refiner',
  CREATE_REFINER: 'create-refiner',
  UPDATE_REFINER: 'update-refiner',
  UPLOAD_REDEMPTION_DATA: 'upload-redemption-data',
  MOBILE_SCAN_QR_CODE: 'mobile-scan-qrcode',
};

export const teamAccessGroupRules = [
  {
    name: 'Dashboard',
    class: 'dashboard',
    desc: 'policy for managing dashboard utility',
    slugs: [teamAccessGroupsSlugs.DASHBOARD],
  },
  {
    name: 'Member',
    class: 'member',
    desc: 'policy for managing member utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_MEMBERS,
      teamAccessGroupsSlugs.INVITE_REMOVE_TEAM_MEMBER,
    ],
  },
  {
    name: 'Team Setting',
    class: 'team',
    desc: 'policy for managing team setting utility',
    slugs: [
      teamAccessGroupsSlugs.MANAGE_TEAM_ROLES,
      teamAccessGroupsSlugs.TEAM_SETTING,
    ],
  },
  {
    name: 'License & Payment',
    class: 'license&payment',
    desc: 'policy for managing team-license &  payment history utility',
    slugs: [
      teamAccessGroupsSlugs.TEAM_LICENSE,
      teamAccessGroupsSlugs.PAYMENT_HISTORY,
      teamAccessGroupsSlugs.CREATE_TEAM_PAYMENT,
    ],
  },
  // {
  //   name: 'Payment',
  //   class: 'payment',
  //   desc: 'policy for managing payment history utility',
  //   slugs: [
  //     teamAccessGroupsSlugs.CREATE_TEAM_PAYMENT,
  //     teamAccessGroupsSlugs.PAYMENT_HISTORY,
  //   ],
  // },
  {
    name: 'Social Accounts',
    class: 'social_account',
    desc: 'policy for managing social account utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_SOCIAL_ACCOUNT,
      teamAccessGroupsSlugs.SOCIAL_ACCOUNT,
    ],
  },
  // {
  //   name: 'Contacts',
  //   class: 'contact',
  //   desc: 'policy for managing contact utility',
  //   slugs: [
  //     teamAccessGroupsSlugs.LIST_CONTACTS,
  //     teamAccessGroupsSlugs.CREATE_CONTACT,
  //     teamAccessGroupsSlugs.EDIT_CONTACT,
  //   ],
  // },
  {
    name: 'Campaigns',
    class: 'campaign',
    desc: 'policy for managing campaign utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_CAMPAIGN,
      teamAccessGroupsSlugs.CREATE_CAMPAIGN,
      teamAccessGroupsSlugs.EDIT_CAMPAIGN,
    ],
  },
  {
    name: 'Ads Set',
    class: 'ad_set',
    desc: 'policy for managing promoter utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_ADS_SET,
      teamAccessGroupsSlugs.CREATE_ADS_SET,
      teamAccessGroupsSlugs.EDIT_ADS_SET,
    ],
  },
  {
    name: 'Ads',
    class: 'ad',
    desc: 'policy for managing promoter utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_ADS,
      teamAccessGroupsSlugs.CREATE_ADS,
      teamAccessGroupsSlugs.EDIT_ADS,
    ],
  },
  {
    name: 'Integrator',
    class: 'integrator',
    desc: 'policy for managing Integrator utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_INTEGRATOR,
      teamAccessGroupsSlugs.CREATE_INTEGRATOR,
      teamAccessGroupsSlugs.EDIT_INTEGRATOR,
      teamAccessGroupsSlugs.INTEGRATOR_APPROVAL,
    ],
  },
  {
    name: 'Analyzer',
    class: 'analyzer',
    desc: 'policy for managing Analyze & Redemption utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_ANALYZER,
      teamAccessGroupsSlugs.CREATE_ANALYZER,
      teamAccessGroupsSlugs.UPLOAD_REDEMPTION_DATA,
    ],
  },
  {
    name: 'Refiner',
    class: 'refiner',
    desc: 'policy for managing Refiner utility',
    slugs: [
      teamAccessGroupsSlugs.LIST_REFINER,
      teamAccessGroupsSlugs.CREATE_REFINER,
      teamAccessGroupsSlugs.UPDATE_REFINER,
    ],
  },
  // {
  //   name: 'Redemption',
  //   class: 'redemption',
  //   desc: 'policy for redemption utility',
  //   slugs: [teamAccessGroupsSlugs.UPLOAD_REDEMPTION_DATA],
  // },
  {
    name: 'Mobile Scan QR Code',
    class: 'mobile_scan_qr_code',
    desc: 'policy for mobile scan qr code utility',
    slugs: [teamAccessGroupsSlugs.MOBILE_SCAN_QR_CODE],
  },
];
